import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class DepotTable extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }

  renderSortHeader = (label, sortKey) => {
    const { onSort, sortDirection, sortKey: activeSortKey } = this.props;
    const active = activeSortKey === sortKey;
    const iconClass = active && sortDirection === "desc"
      ? "fa fa-sort-down"
      : active
        ? "fa fa-sort-up"
        : "fa fa-sort";

    return (
      <button
        className={`depot-sort-button ${active ? "active" : ""}`}
        onClick={() => onSort(sortKey)}
        type="button"
      >
        {label}
        <i className={iconClass}></i>
      </button>
    );
  };

  render() {
    const { depots, readOnly } = this.props;
    return (
      <Table className="depot-table" responsive>
        <thead>
          <tr>
            <th>{this.renderSortHeader("Name", "name")}</th>
            <th>{this.renderSortHeader("Description", "description")}</th>
            <th>{this.renderSortHeader("Customer", "customerName")}</th>
            <th>{this.renderSortHeader("Time Zone", "timeZoneCity")}</th>
            <th>{this.renderSortHeader("MapOverlay", "mapOverlay")}</th>
            <th>{this.renderSortHeader("Updated", "dbUpdated")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {depots.length === 0 && (
            <tr>
              <td className="depot-empty" colSpan="7">
                No depots match your search.
              </td>
            </tr>
          )}
          {depots.map((depot, index) => {
            return (
              <tr key={index}>
                <td>
                  <strong>{depot.name}</strong>
                </td>
                <td>{depot.description || "-"}</td>

                <td>
                  <a
                    className="depot-customer-link"
                    onClick={() =>
                      localStorage.setItem(
                        "customer",
                        JSON.stringify({
                          customerId: depot.customerId,
                          customerName: depot.customerName,
                        })
                      )
                    }
                    href={`/depots?customerId=${depot.customerId}&customerName=${depot.customerName}`}
                  >
                    {depot.customerName}
                  </a>
                </td>

                <td>{depot.timeZoneCity}</td>
                <td className="width-adjust">{depot.mapOverlay || "-"}</td>
                <td>{utcToLocal(depot.dbUpdated)}</td>

                <td className="depot-actions">
                  <div className="depot-actions-inner">
                    {readOnly ? (
                      <Link to={`/viewDepot/${depot.id}`}>View</Link>
                    ) : (
                      <>
                        <Link to={`/editDepot/${depot.id}`}>Edit</Link>
                        <Link to={`/depotDetails/${depot.id}`}>Details</Link>
                        <Link to={`/deleteDepot/${depot.id}`}>Delete</Link>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default DepotTable;
